import { SuportAreaTranslations } from "./suport-area-pt-br";

export const SUPORT_AREA_FR_FR: SuportAreaTranslations = {
	title: "Centre d'aide",
	questionTitle: "Besoin d'aide ?",
	questionDescription:
		"Ouvrez un nouveau ticket ou suivez ceux déjà en cours avec notre équipe.",
	openTicket: "Parler à un conseiller",
	close: "Fermer",
};
